import { render, staticRenderFns } from "./AddAWSRoleSidePanel.vue?vue&type=template&id=f76c1b76&"
import script from "./AddAWSRoleSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddAWSRoleSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports